// eslint-disable-next-line
export const getBackendUrl = () => {
  return process.env.REACT_APP_BACKEND_URL || 'http://localhost:8081';
};

export const getFeatBitConfig = () => ({
  sdkKey: process.env.REACT_APP_FEATBIT_SDK_KEY || '',
  streamingUri: process.env.REACT_APP_FEATBIT_STREAMING_URI || '',
  eventsUri: process.env.REACT_APP_FEATBIT_EVENTS_URI || '',
});
